import { Icon, IconProps } from './Icon';

interface TripStartIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const TripStartIcon = ({ color = '#5E6A81', gradient, ...props }: TripStartIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M15.832 20.4163H18.9587"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.3947 20.4163V14.583L15.6914 16.123"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M24.5 10.5003H3.5"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.33333 3.36035V5.97368"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M18.6663 3.36035V5.97368"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 24.5003H7C5.06683 24.5003 3.5 22.9335 3.5 21.0003V8.16699C3.5 6.23383 5.06683 4.66699 7 4.66699H21C22.9332 4.66699 24.5 6.23383 24.5 8.16699V21.0003C24.5 22.9335 22.9332 24.5003 21 24.5003Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.625 15.703C9.8105 15.0613 10.3775 14.583 11.0787 14.583C11.928 14.583 12.6175 15.2713 12.6175 16.1218C12.6175 16.8825 12.0003 17.4997 11.2397 17.4997C12.0003 17.4997 12.6175 18.1168 12.6175 18.8775C12.6175 19.7268 11.9292 20.4163 11.0787 20.4163C10.3775 20.4163 9.8105 19.938 9.625 19.2963"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
